import { render } from "./ReportPostModal.vue?vue&type=template&id=55a56091"
import script from "./ReportPostModal.vue?vue&type=script&lang=js"
export * from "./ReportPostModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__